import { EntityOption } from "../app/admin/components/EntitySelector";

// Configuración de colores para Gestión Curricular
export const gestionCurricularOptions: EntityOption[] = [
  {
    id: "tema",
    label: "Temas",
    description: "Gestionar temas",
    color: {
      selected: {
        border: "border-orange-400",
        bg: "bg-orange-50",
        text: "text-orange-600",
        description: "text-orange-500",
      },
      unselected: {
        border: "border-gray-200",
        hover: {
          border: "hover:border-orange-300",
          bg: "hover:bg-orange-50",
        },
      },
    },
  },
  {
    id: "anioEscolar",
    label: "Años Escolares",
    description: "Gestionar años",
    color: {
      selected: {
        border: "border-green-400",
        bg: "bg-green-50",
        text: "text-green-600",
        description: "text-green-500",
      },
      unselected: {
        border: "border-gray-200",
        hover: {
          border: "hover:border-green-300",
          bg: "hover:bg-green-50",
        },
      },
    },
  },
  {
    id: "grupo",
    label: "Grupos",
    description: "Gestionar grupos",
    color: {
      selected: {
        border: "border-blue-400",
        bg: "bg-blue-50",
        text: "text-blue-600",
        description: "text-blue-500",
      },
      unselected: {
        border: "border-gray-200",
        hover: {
          border: "hover:border-blue-300",
          bg: "hover:bg-blue-50",
        },
      },
    },
  },
  {
    id: "unidad",
    label: "Unidades",
    description: "Gestionar unidades",
    color: {
      selected: {
        border: "border-purple-400",
        bg: "bg-purple-50",
        text: "text-purple-600",
        description: "text-purple-500",
      },
      unselected: {
        border: "border-gray-200",
        hover: {
          border: "hover:border-purple-300",
          bg: "hover:bg-purple-50",
        },
      },
    },
  },
];

// Configuración de colores para Modo Historia
export const modoHistoriaOptions: EntityOption[] = [
  {
    id: "mundo",
    label: "Mundos",
    description: "Gestionar mundos",
    color: {
      selected: {
        border: "border-orange-400",
        bg: "bg-orange-50",
        text: "text-orange-600",
        description: "text-orange-500",
      },
      unselected: {
        border: "border-gray-200",
        hover: {
          border: "hover:border-orange-300",
          bg: "hover:bg-orange-50",
        },
      },
    },
  },
  {
    id: "etapa",
    label: "Etapas",
    description: "Gestionar etapas",
    color: {
      selected: {
        border: "border-green-400",
        bg: "bg-green-50",
        text: "text-green-600",
        description: "text-green-500",
      },
      unselected: {
        border: "border-gray-200",
        hover: {
          border: "hover:border-green-300",
          bg: "hover:bg-green-50",
        },
      },
    },
  },
];
